import { create } from 'zustand';

interface BuilderOverlayState {
  isOpen: boolean;
  productId: string | null;
  designId: string | null;
  productSlug: string | null;
  onSaveCallback: ((designId: string) => void) | null;

  openBuilder: (params: {
    productId?: string;
    designId?: string;
    productSlug?: string;
    onSave?: (designId: string) => void;
  }) => void;
  closeBuilder: () => void;
}

export const useBuilderOverlay = create<BuilderOverlayState>((set) => ({
  isOpen: false,
  productId: null,
  designId: null,
  productSlug: null,
  onSaveCallback: null,

  openBuilder: ({ productId, designId, productSlug, onSave }) =>
    set({
      isOpen: true,
      productId: productId ?? null,
      designId: designId ?? null,
      productSlug: productSlug ?? null,
      onSaveCallback: onSave ?? null,
    }),

  closeBuilder: () =>
    set({
      isOpen: false,
      productId: null,
      designId: null,
      productSlug: null,
      onSaveCallback: null,
    }),
}));
